(function() {
  function setupConsoleIntercept() {
    const startTime = Date.now();
    const TIMEOUT_MS = 3000;
    const LOG_FLUSH_INTERVAL_MS = 100;

    let logQueue: Array<{level: string, message: string}> = [];
    let flushTimer: number | null = null;
    let tauriInvoke: ((cmd: string, args: Record<string, unknown>) => Promise<void>) | null = null;

    function flushLogs() {
      if (logQueue.length === 0) return;
      const entries = logQueue.splice(0, logQueue.length);
      if (tauriInvoke) {
        // The Rust command takes a single `args: { entries: [...] }`
        // struct. The inner `LogEntry` uses snake_case (rename_all)
        // but every field is single-word, so the keys are unchanged
        // (level, message).
        tauriInvoke('log_batch_from_webview', {args: {entries}}).catch(() => {});
      }
      flushTimer = null;
    }

    function queueLog(level: string, message: string) {
      logQueue.push({ level, message });
      if (flushTimer === null) {
        flushTimer = window.setTimeout(flushLogs, LOG_FLUSH_INTERVAL_MS);
      }
    }

    function tryIntercept() {
      // @ts-ignore
      const invokeFn = window.__TAURI__?.core?.invoke || window.__TAURI_INTERNALS__?.invoke;
      // @ts-ignore
      const tauriEmit = window.__TAURI__?.event?.emit || window.__TAURI_INTERNALS__?.event?.emit;

      if (!invokeFn || !tauriEmit) {
        if (Date.now() - startTime < TIMEOUT_MS) {
          setTimeout(tryIntercept, 50);
        }
        return;
      }

      tauriInvoke = invokeFn as typeof tauriInvoke;

      const originalLog = console.log;
      const originalWarn = console.warn;
      const originalError = console.error;
      const originalInfo = console.info;
      const originalDebug = console.debug;

      function formatMessage(args: unknown[]): string {
        return args.map(a => {
          try {
            return typeof a === 'object' ? JSON.stringify(a) : String(a);
          } catch {
            return String(a);
          }
        }).join(' ');
      }

      console.log = function(...args: unknown[]) {
        originalLog.apply(console, args);
        queueLog('log', formatMessage(args));
      };

      console.warn = function(...args: unknown[]) {
        originalWarn.apply(console, args);
        queueLog('warn', formatMessage(args));
      };

      console.error = function(...args: unknown[]) {
        originalError.apply(console, args);
        queueLog('error', formatMessage(args));
      };

      console.info = function(...args: unknown[]) {
        originalInfo.apply(console, args);
        queueLog('info', formatMessage(args));
      };

      console.debug = function(...args: unknown[]) {
        originalDebug.apply(console, args);
        queueLog('debug', formatMessage(args));
      };

      console.log('[Tauri] Console intercept initialized successfully');
    }

    tryIntercept();
  }

  setupConsoleIntercept();
})();

// Initialize BIOS global properties
// This file must be imported FIRST in index.ts before any other imports
try {
    const urlParams = new URLSearchParams(window.location.search);
    const storedLoginMode = localStorage.getItem('loginMode');
    const existingBIOS = (window as any).BIOS as Partial<typeof window.BIOS> | undefined;

    // Get the base origin, handling special cases for file:// and tauri:// protocols
    const baseOrigin = window.location.origin.startsWith("file://") || window.location.origin.startsWith("tauri:")
        ? "http://localhost:8000"
        : window.location.origin.replace("3000", "8000");
    let researchBaseOrigin =  window.location.origin.startsWith("file://") || window.location.origin.startsWith("tauri:")
        ? "http://localhost:8051"
        : window.location.origin.replace("3000", "8051").replace("8000", "8051");
    researchBaseOrigin = researchBaseOrigin.replace("neurotune", "research")

    const resolvedLoginMode = (urlParams.get('lm') || storedLoginMode || existingBIOS?.loginMode || "popup") as "redirect" | "popup"
    const resolvedNeurotuneBase = existingBIOS?.neurotune_base_url || baseOrigin
    const resolvedResearchBase = existingBIOS?.research_base_url || researchBaseOrigin
    const resolvedHeaders = existingBIOS?.headers || {}

    window.BIOS = {
        // Respect host-injected values first (NDC packaged env), then fallback
        // to browser/dev inference.
        neurotune_base_url: resolvedNeurotuneBase,
        research_base_url: resolvedResearchBase,
        loginMode: resolvedLoginMode,
        headers: resolvedHeaders,
    }
    localStorage.setItem('loginMode', window.BIOS.loginMode);
    console.log('BIOS initialized:', {
        bios: window.BIOS,
        hadInjectedConfig: !!existingBIOS,
        urlLm: urlParams.get('lm'),
        storedLoginMode,
    });
} catch (e) {
    console.error("Error setting up global BIOS properties:", e);
}

